import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { AnalysisPointDeleteRate } from 'utils/_function';
import { useRecoilValue } from 'recoil';
import { debugFlagState } from 'atoms/projectData';

const useStyles = makeStyles((theme) => ({
  panel: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    position: "absolute",
    top: "0px",
    right: "55px",
    textAlign: 'center',
    fontSize: '11px',
    fontWeight: 'normal',
  },
  box: {
    background: 'rgba(255,255,255,0.8);',
    padding: '2px 5px 2px 5px',
  }
}));

export default function ProjectDetail(props) {
  const classes = useStyles();
  const { pjName, analysisFilterCalcRate, projectId, isAnalysisFilterCalc } = props;
  // Recoilから取得
  const debugFlag = useRecoilValue(debugFlagState);

  return (
    <div className={classes.panel}>
      {isAnalysisFilterCalc && 
        <div className={classes.box} style={{ marginRight: "10px" }}>
          点の数: {analysisFilterCalcRate.FilterPointNum} / {analysisFilterCalcRate.allPointNum}（{AnalysisPointDeleteRate(analysisFilterCalcRate)}）
        </div>
      }
      <div className={classes.box}>
        {pjName} {debugFlag && projectId}
      </div>
    </div>
  )
}